import { useState } from 'react';
import { PlusIcon } from '@heroicons/react/24/outline';
import { CreateBillComCustomerModal, type BillComPrefill } from './CreateBillComCustomerModal';

interface CreateBillComCustomerActionProps {
    practiceId: string;
    prefill: BillComPrefill;
}

// Sits below the billId field (as an accessory - see DetailsTab's
// fieldAccessories) while it's empty, alongside the field's own input rather
// than in place of it - the user can type an id directly or use this button.
// Once a customer is created the field itself shows the id and this button
// stops rendering entirely, so there's no "create another" path for a
// practice that already has one.
export function CreateBillComCustomerAction({
    practiceId,
    prefill
}: CreateBillComCustomerActionProps) {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <button
                type="button"
                onClick={() => setIsOpen(true)}
                className="self-start inline-flex items-center gap-1.5 h-8 px-3 rounded-md border border-gray-300 bg-white text-[13px] font-semibold text-gray-700 hover:bg-gray-50 hover:border-gray-400 transition-colors"
            >
                <PlusIcon className="h-3.5 w-3.5" />
                Create Bill.com customer
            </button>
            {isOpen && (
                <CreateBillComCustomerModal
                    practiceId={practiceId}
                    prefill={prefill}
                    onClose={() => setIsOpen(false)}
                />
            )}
        </>
    );
}
